import { StyleSheet, I18nManager, Platform } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  buttonStyle: {
    marginHorizontal: 10,
  },
  buttonTextStyle: {
    fontSize: 18.7,
    letterSpacing: 0,
    lineHeight: 24,
  },
  secondaryButtonStyle: {
    marginHorizontal: 10,
  },

  orText: theme => ({
    textAlign: 'center',
    marginVertical: 18,
    fontSize: 15.6,
    color: theme.colors.sectionHeaderTextColor,
  }),
  containerStyle: {
    paddingBottom: 25,
    paddingHorizontal: 10,
    paddingTop: 5,
  },
  labelTextStyle: {
    fontFamily: Fonts.type.VFFont,
    paddingTop: 1,
  },
  logInOptionsContainerStyle: showRememberMe => ({
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: showRememberMe ? 'space-between' : 'center',
    marginBottom: 30,
    marginTop: 10,
    marginHorizontal: 10,
  }),
  passwordInputStyle: {
    marginTop: 15,
  },
  rememberMeTextStyle: theme => ({
    color: theme.colors.rememberMeText,
    fontSize: 14.6,
    lineHeight: 18.7,
    paddingTop: Platform.OS === 'ios' ? 3 : null,
  }),
  textStyle: theme => ({
    color: theme.colors.headerColor,
    fontSize: 14.6,
    lineHeight: 18.7,
    fontFamily: Fonts.type.VFFont,
    textDecorationLine: 'underline',
  }),
  toggleContainerStyle: {
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: I18nManager.isRTL ? 16 : 0,
    marginRight: I18nManager.isRTL ? 0 : 16,
  },
  forgetBtn: {
    alignItems: 'flex-end',
    width: 145.6,
  },
  toggleStyle: {
    marginLeft: I18nManager.isRTL ? 10 : 0,
    marginRight: I18nManager.isRTL ? 0 : 10,
    backgroundColor: Colors.brownGrey,
    borderColor: Colors.brownGrey,
  },
  disabledBUttonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
});
